<template>
<section class="pt-8 pt-md-5 pb-8 pb-md-14">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="mb-0 fw-bold">Billing</h1>
                <p class="mb-6 text-muted">
                    Funds are debited hourly according to your chosen plan
                </p>
                <div class="row mb-5">
                    <div class="col">
                        <h4 class="mb-0">
                            <small class="text-gray-700">{{ $state.context.currency_symbol }}</small>{{ $state.context.amount }}
                        </h4>
                        <small class="text-gray-700">Balance</small>
                    </div>
                    <div class="col-auto">
                        <router-link :to="{path: '/billing/pay'}" class="btn btn-xl btn-primary">
                            Top up your balance
                        </router-link>
                    </div>
                </div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'payments'}" @click="tab = 'payments'" href="#payments">
                            Payments
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'transactions'}" @click="tab = 'transactions'" href="#transactions">
                            Transactions
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': tab == 'purchases'}" @click="tab = 'purchases'" href="#purchases">
                            Purchases
                        </a>
                    </li>
                </ul>
                <Payments v-if="tab == 'payments'" />
                <Transactions v-if="tab == 'transactions'" />
                <Purchases v-if="tab == 'purchases'" />
            </div>
        </div>
    </div>
</section>
</template>

<script>
import Payments from "./Payments"
import Transactions from "./Transactions"
import Purchases from "./Purchases"

export default {
    components: {
        Payments,
        Transactions,
        Purchases
    },
    data() {
        return {
            tab: location.hash.slice(1) || 'payments'
        }
    },
}
</script>
